/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var AwardMedalIcon20Solid = forwardRef('AwardMedalIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "m2.303 2.968 2.84 4.321A7.47 7.47 0 0 1 10 5.504a7.47 7.47 0 0 1 4.857 1.785l2.84-4.32A.625.625 0 0 0 17.175 2h-4.74a.625.625 0 0 0-.534.3L10 5.423 8.1 2.3a.625.625 0 0 0-.535-.3h-4.74a.625.625 0 0 0-.522.968Z" }),
        React.createElement("path", { d: "M10 19a6 6 0 1 0 0-12 6 6 0 0 0 0 12Z" })));
});
